import { useRegisterSW } from 'virtual:pwa-register/react';

const UPDATE_CHECK_MS = 60 * 60_000;

/**
 * Registers the service worker and offers new versions. The app stays on the
 * cached version until the person chooses to reload. An installed PWA can stay
 * open for days, so it also checks for updates hourly.
 */
export function UpdateBanner() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (registration) setInterval(() => void registration.update().catch(() => {}), UPDATE_CHECK_MS);
    },
  });

  if (!needRefresh) return null;
  return (
    <div className="update-banner" role="status">
      <span>A new version of Squats is ready.</span>
      <button type="button" className="btn small primary" onClick={() => void updateServiceWorker()}>
        Reload
      </button>
    </div>
  );
}
